import styled from 'styled-components'
import TextArea from '@ui-library/core/TextArea'
import Accordion from '@ui-library/core/Accordion'

import * as BannerImgXLPng from '../../../assets/contact-banner-large.png'
import * as BannerImgMediumPng from '../../../assets/contact-banner-tablet.png'
import * as BannerImgSmallPng from '../../../assets/contact-banner-mobile.png'

export const Banner = styled.div`
  height: 280px;
  padding: 16px;
  background: url(${BannerImgXLPng});

  @media screen and (max-width: 480px) {
    background: url(${BannerImgSmallPng});
  }

  @media screen and (min-width: 481px) and (max-width: 1024px) {
    background: url(${BannerImgMediumPng});
  }
`
export const BannerMessageContainer = styled.div`
  width: 464px;
`

export const BannerTitle = styled.h1`
  font-weight: bold;
  font-size: 40px;
  margin: 4px 0;
`

export const BannerSubtitle = styled.p`
  font-weight: 600;
  font-size: 16px;
`

export const BannerText = styled.p`
  font-weight: 400;
  font-size: 16px;
`

export const BannerContent = styled.div`
  max-width: 1280px;
  margin: auto;
  display: flex;
  align-items: center;
  height: inherit;
`

export const ErrorMessage = styled.div`
  background-color: #c5071b;
  color: #fff;
  padding: 4px 0;
  text-indent: 14px;
  margin-bottom: 10px;
`

export const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  height: 200px;
  width: 100%;
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;

  div {
    margin-bottom: 24px;
  }
`

export const SliceRegie = styled.p`
  display: inline-block;
  width: calc(100% - 120px);
  padding-left: 12px;
  vertical-align: text-bottom;
`
export const LogoRegie = styled.div`
  display: inline-block;
  padding-right: 12px;
  border-right: 1px solid #ccd1d9;
`

export const LinkButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: #00819e;
  &.formButton {
    font-size: 12px;
  }
`

export const StyledTextArea = styled(TextArea)`
  width: 100%;
  min-width: 100%;
  grid-column: 2 / 3;
  grid-row: 1 / 4;
  height: 100%;
  div:first-child {
    height: 100%;
  }
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: repeat(1fr, 3);
  grid-gap: 16px;
  margin-bottom: 24px;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form-input {
    grid-column: 1 / 2;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`

export const RequiredInfo = styled.p`
  font-size: 12px;
  padding-bottom: 0;
`

export const StyledH3 = styled.div`
  margin: 0 0 24px 0;
  text-align: left;
`

export const PersonalDisclaimer = styled.div`
  margin-top: 12px;
  p {
    font-size: 12px;
    color: #494949;
    margin: 0 0 8px 0;
    padding: 0;
  }
`

export const StyledH2 = styled.h2`
  padding-top: 40px;
  font-size: 22px;
  font-weight: bold;
  text-align: left;
  margin: 0 0 24px 0;
`

export const FormulaireContact = styled.div`
  background-color: #f5f7fa;
  padding: 0 24px 40px 24px;
`

export const FormulaireContactH3 = styled.h3`
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
`

export const LayMain = styled.div`
  display: table-cell;
  vertical-align: top;
  text-align: left;
`

export const Lay = styled.div`
  display: table;
  width: 100%;
`

export const Wrapper = styled.div`
  max-width: 1280px;
  margin: auto;
  background-color: #fff;
  text-align: left;
  @media screen and (max-width: 1280px) {
    padding: 0 16px;
  }
`

export const Main = styled.div`
  font-family: inherit;
`

export const FormButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 24px;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`

export const MainContainer = styled.div`
  margin-top: 32px;
`

export const SliceContainer = styled.div`
  text-align: left !important;
  border-bottom: 1px solid #ccd1d9;
  margin: 0 24px;
  padding-bottom: 40px;
`

export const StyledAccordion = styled(Accordion)`
  margin: 10px 0;
`

export const AccordionContent = styled.div`
  margin: 0 16px;
  &.withSeparator {
    margin: 0;
  }
`

export const ContactUsContent = styled.div`
  margin: 8px 16px;
`

export const StyledTitle = styled.h3`
  font-size: 16px;
  margin: 0;
`
